import { connect } from 'react-redux'
import { preRegistrationsActions, messageActions } from '../../actions'
import { withStyles } from '@material-ui/core/styles'
import * as ContentType from 'informed-shared/components/es/ContentType'
import Button from '@material-ui/core/Button'
import CircularProgress from '@material-ui/core/CircularProgress'
import Dialog from '../../components/IdentifiedDialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import FormControl from '@material-ui/core/FormControl'
import InputLabel from '@material-ui/core/InputLabel'
import MenuItem from '@material-ui/core/MenuItem'
import PropTypes from 'prop-types'
import React, { Fragment, Component } from 'react'
import Select from '@material-ui/core/Select'
import Typography from '@material-ui/core/Typography'
import withMobileDialog from '@material-ui/core/withMobileDialog'
import { Curso, Livro } from './PreRegistrationTypes'
import { readOnly } from '../../utils/permissions'
import jwt_decode from 'jwt-decode'

const styles = theme => ({
  box: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16,
    margin: 'auto',
    width: '80%',
    maxWidth: '400px',
    background: 'blue'
  }),
  errorMessage: {
    position: 'absolute',
    bottom: '-22px',
    left: 0
  },
  wrapperLoader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: '280px',
    width: '100%',
    height: '100%',
    minHeight: '200px'
  },
  formGroup: {
    padding: '12px 0'
  },
  root: {
    display: 'flex',
    minHeight: '100%',
    padding: '16px 0',
    boxSizing: 'border-box',
    flexDirection: 'column',
    background: '#fafafa'
  },
  formControl: {
    margin: '14px 0'
  },
  gridInfo: {
    marginBottom: '14px'
  },
  labelSpacing: {
    marginTop: theme.spacing.unit
  },
  link: {
    color: '#002d72'
  }
})

class EditModal extends Component {
  handleSave = preRegistration => {
    const { onClose, addPreRegistration, editPreRegistration, changeMessage } = this.props

    if (preRegistration._id) {
      editPreRegistration(preRegistration).then(res => {
        changeMessage({ message: 'Alteração realizada com sucesso.' })
        onClose()
      })
    } else {
      addPreRegistration(preRegistration).then(res => {
        changeMessage({ message: 'Cadastro realizado com sucesso.' })
        onClose()
      })
    }
  }

  handleSubmit = (e, preRegistration) => {
    e.preventDefault()
    const { setPreRegistrationFormTouched } = this.props

    if (this.props.preRegistrationFormErrors.valid) {
      this.handleSave(preRegistration)
    } else {
      setPreRegistrationFormTouched()
    }

    return false
  }

  clearErrors = () => {
    this.setState({ formErrors: {} })
  }

  preRegistrationTypes = () => {
    try {
      const { token } = this.props
      const userToken = jwt_decode(token)
      if (!userToken) return []
      const types = [{ name: 'Curso', value: 'curso' }, { name: 'Livro', value: 'livro' }]
      const permissoes = ((userToken.user || {}).perfil || {}).permissoes || []
      const filtered = permissoes.reduce((prev, cur) => {
        const alias = ((cur || {}).funcionalidade || {}).alias || ''
        if (/preCadastros-/.test(alias)) {
          const found = types.find(t => t.value === alias.replace(/preCadastros-/, ''))
          return found ? [...prev, found] : prev
        }
        return prev
      }, [])
      return filtered.length > 0 ? filtered : types
    } catch (e) {
      return [{ name: 'Curso', value: 'curso' }, { name: 'Livro', value: 'livro' }]
    }
  }

  render() {
    const {
      fullScreen,
      onClose,
      open = false,
      classes,
      preRegistration,
      handleChangePreRegistration,
      loadingPreRegistration,
      preRegistrationFormErrors,
      formTouched,
      token
    } = this.props

    const { handleSubmit, preRegistrationTypes } = this

    const isReadOnly = readOnly(preRegistration.tipo, token)

    return (
      <div>
        <Dialog
          modalId={preRegistration._id ? 'pre-cadastros-editar' : 'pre-cadastros-novo'}
          modalParams={{ registro: preRegistration._id, tipo: preRegistration.tipo }}
          fullScreen={fullScreen}
          fullWidth
          open={open}
          onClose={onClose}
          className={classes.dialog}
        >
          {loadingPreRegistration ? (
            <div className={classes.wrapperLoader}>
              <CircularProgress />
            </div>
          ) : (
            <Fragment>
              <DialogTitle id={(preRegistration._id ? 'pre-cadastros-editar' : 'pre-cadastros-novo') + '-title'}>
                {isReadOnly ? (
                  'Pré-cadastro'
                ) : (
                  <Fragment>
                    {preRegistration._id ? 'Editar pré-cadastro' : 'Adicionar pré-cadastro'}
                  </Fragment>
                )}
              </DialogTitle>

              <DialogContent>
                <form
                  id={'preRegistration-form'}
                  noValidate
                  onSubmit={e => {
                    handleSubmit(e, preRegistration)
                  }}
                >
                  <FormControl
                    error={
                      !((preRegistrationFormErrors.fields || {})['tipo'] || {}).valid && formTouched
                    }
                    fullWidth
                    className={classes.formControl}
                  >
                    <InputLabel htmlFor="content-type">Tipo do pré-cadastro</InputLabel>
                    <Select
                      id="content-type"
                      value={preRegistration.tipo}
                      disabled={!!preRegistration._id}
                      onChange={e => {
                        handleChangePreRegistration({ ...preRegistration, tipo: e.target.value })
                      }}
                    >
                      {preRegistrationTypes().map(item => (
                        <MenuItem key={item.value} value={item.value}>
                          {item.name}
                        </MenuItem>
                      ))}
                    </Select>

                    {!((preRegistrationFormErrors.fields || {})['tipo'] || {}).valid &&
                    formTouched ? (
                      <Typography className={classes.errorMessage} noWrap color={'error'}>
                        {((preRegistrationFormErrors.fields || {})['tipo'] || {}).errorMessage}
                      </Typography>
                    ) : null}
                  </FormControl>

                  <ContentType.Render type={preRegistration.tipo} types={['curso']}>
                    <Curso />
                  </ContentType.Render>

                  <ContentType.Render type={preRegistration.tipo} types={['livro']}>
                    <Livro />
                  </ContentType.Render>
                </form>
              </DialogContent>

              <DialogActions>
                <Button onClick={onClose} color="default">
                  {isReadOnly ? 'Fechar' : 'Cancelar'}
                </Button>

                {!isReadOnly && (
                  <Button
                    type={'submit'}
                    form={'preRegistration-form'}
                    color="primary"
                    variant="raised"
                  >
                    Salvar
                  </Button>
                )}
              </DialogActions>
            </Fragment>
          )}
        </Dialog>
      </div>
    )
  }
}

EditModal.propTypes = {
  fullScreen: PropTypes.bool.isRequired
}

const mapStateToProps = state => {
  return {
    preRegistration: state.preRegistrations.preRegistration,
    loadingPreRegistration: state.preRegistrations.loadingPreRegistration,
    preRegistrationFormErrors: state.preRegistrations.preRegistrationFormErrors,
    formTouched: state.preRegistrations.preRegistrationFormTouched,
    statuses: state.preRegistrations.statuses,
    token: state.auth.token
  }
}

const mapDispatchToProps = dispatch => {
  return {
    openModal: () => {
      dispatch(preRegistrationsActions.openModal())
    },
    closeModal: () => {
      dispatch(preRegistrationsActions.closeModal())
    },
    handleChangePreRegistration: preRegistration => {
      dispatch(preRegistrationsActions.handleChangePreRegistration(preRegistration))
    },
    addPreRegistration: preRegistration => {
      return dispatch(preRegistrationsActions.addPreRegistration(preRegistration))
    },
    editPreRegistration: preRegistration => {
      return dispatch(preRegistrationsActions.editPreRegistration(preRegistration))
    },
    setPreRegistrationFormTouched: preRegistration => {
      dispatch(preRegistrationsActions.setPreRegistrationFormTouched())
    },
    changeMessage: ({ message }) => {
      dispatch(messageActions.changeMessage({ message }))
    },
    fetchPreRegistrations: ({ page, perPage }) => {
      dispatch(preRegistrationsActions.fetchPreRegistrations({ page, perPage }))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withMobileDialog()(withStyles(styles)(EditModal)))



// WEBPACK FOOTER //
// ./src/containers/PreRegistration/EditModal.js